// Dove vive la sessione del volantino.
//
// view.inpublish.it serve i volantini di tutti i clienti dallo stesso origin:
// il cliente e il volantino sono solo pezzi del path, e il localStorage non
// guarda il path. Una chiave fissa e' quindi una cassetta in comune fra
// clienti diversi, ed e' il motivo per cui un login fatto su un volantino si
// vedeva su tutti gli altri.
//
// La chiave porta dentro il volantino: la sessione vale li' e in nessun altro
// posto. Due volantini dello stesso cliente restano due login distinti, perche'
// l'accesso lo decide l'utente un volantino alla volta.
//
// Dipende solo da fakeServer, come nativeBridge: passare da helper/utility
// creerebbe un ciclo di import (utility -> manager -> Form.component ->
// api.services).
import { serverResponse } from "../util/fakeServer";

// Chiavi in uso fino a settembre 2026, senza volantino: quello che e' rimasto
// dentro non lo legge piu' nessuno.
const LEGACY_TOKENS_KEY = "inpublish_auth_tokens";
const LEGACY_USER_KEY = "inpublish_auth_user";

// client_code/slug e' il path del volantino: univoco e stabile finche' il
// volantino esiste. Non release_id, che cambia a ogni ripubblicazione e
// sloggherebbe tutti ogni volta che il cliente aggiorna il volantino.
const scope = () => {
  const { client_code, slug } = serverResponse.config;
  return `${client_code || "none"}/${slug || "none"}`;
};

const tokensKey = () => `${LEGACY_TOKENS_KEY}:${scope()}`;
const userKey = () => `${LEGACY_USER_KEY}:${scope()}`;

// Volantino senza login: non c'e' nessuna sessione da ricordare, nemmeno una
// arrivata da altrove. Seconda rete sotto alla chiave, per le config in cui
// client_code o slug mancano e lo scope perde la sua parte distintiva.
const loginEnabled = () => !!serverResponse.config.allow_login;

const read = (key) => {
  try {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

export const readTokens = () => (loginEnabled() ? read(tokensKey()) : null);

export const readUser = () => (loginEnabled() ? read(userKey()) : null);

export const writeTokens = (tokens) => {
  try {
    localStorage.setItem(tokensKey(), JSON.stringify(tokens));
  } catch { /* ignore */ }
};

export const writeUser = (user) => {
  try {
    localStorage.setItem(userKey(), JSON.stringify(user));
  } catch { /* ignore */ }
};

export const clearSession = () => {
  try {
    localStorage.removeItem(tokensKey());
    localStorage.removeItem(userKey());
  } catch { /* ignore */ }
};

// Pulizia all'avvio. Una sessione che nessuno puo' piu' leggere non resta nel
// browser ad aspettare: sono quelle nate prima di questa patch (chiavi senza
// volantino, invisibili al resto del codice ma ancora li') e quella di un
// volantino a cui il login e' stato tolto dopo che qualcuno era entrato.
export const purgeUnreadableSessions = () => {
  try {
    localStorage.removeItem(LEGACY_TOKENS_KEY);
    localStorage.removeItem(LEGACY_USER_KEY);
  } catch { /* ignore */ }
  if (!loginEnabled()) clearSession();
};
